// AUTO-GENERATED - DO NOT EDIT MANUALLY TO ADD GAMES
// To add a game: Create a folder /GameName/ with GameName.js exporting 'default' (Component) and 'metadata'.

// CAMBIO: Búsqueda RECURSIVA (true) en vez de plana (false)
const requireModule = require.context('.', true, /\.js$/);

const gamesMap = new Map();

requireModule.keys().forEach((fileName) => {
    // Exclude self (GameLoader.js) and generic index files
    if (fileName.includes('GameLoader') || fileName.includes('index')) return;

    // NUEVO: Compatibilidad Dual (Flat + Folders)
    // 1. Folder Strategy: ./GuessWho/GuessWho.js
    const folderMatch = fileName.match(/^\.\/(\w+)\/(\1)\.js$/);

    // 2. Flat Strategy: ./ReactionTest.js (Legacy support)
    const flatMatch = fileName.match(/^\.\/(\w+)\.js$/);

    if (!folderMatch && !flatMatch) return; // Skip auxiliary files like Board.js, Socket.js

    const module = requireModule(fileName);

    // Validate module structure
    if (!module.default || !module.metadata) {
        return;
    }

    // Prefer folder name as ID, or filename for flat
    const id = module.metadata.id || (folderMatch ? folderMatch[1] : flatMatch[1]).toLowerCase().replace(/_/g, '-');

    if (!gamesMap.has(id)) {
        gamesMap.set(id, {
            ...module.metadata,
            Component: module.default,
            id
        });
    }
});

const games = Array.from(gamesMap.values());

export default games;
